<template>
  <div
    class="bg-white relative rounded-2xl border grid gap-2 pb-2 shadow-md overflow-hidden"
  >
    <Top :data="data" />
    <Post
      :class="{ lock: data.is_fake }"
      :data="data"
      :isCollection="isCollection"
    />
    <Bottom :data="data" />
  </div>
</template>

<script>
import Post from "./Post";
import Bottom from "./Bottom";
import Top from "./Top.vue";
export default {
  components: { Post, Bottom, Top },
  props: {
    data: Object,
    isCollection: Boolean,
    unlock: Boolean,
  },
};
</script>

<style>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
</style>
